export function items() {
    return [
    {
      "id": "346203621022525649",
      "title": "彩霞岭社区",
      "name": "上城区",
      "content": "紫阳街道彩霞岭社区旧改以解决老百姓关心的社区问题为出发点，对现有服务设施进行有效提升，全面提升了居民日常生活品质。",
      "image": "http://cst.hzcst.cn/guodi/3fMBntNzE5.jpg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621022591185",
      "title": "景新社区",
      "name": "上城区",
      "content": "凯旋街道景新社区将老旧小区改造与未来社区创建有机融合，在改造中真正体现居民全流程参与的“享受未来 健康生活”的旧改丰富内涵。",
      "image": "http://cst.hzcst.cn/guodi/BBkBj37BTX.jpg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621022656721",
      "title": "复兴北苑",
      "name": "上城区",
      "content": "南星街道复兴北苑围绕“党建引领，未来社区与历史传承两翼共振”的改造理念，实现复兴南街周边区域“凤凰涅槃”式的面貌与功能双提升。",
      "image": "http://cst.hzcst.cn/guodi/bABDKzXSyG.jpg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621022722257",
      "title": "定安路社区",
      "name": "上城区",
      "content": "清波街道定安路社区坚持以“民声”引领“民主”，居民“按需定制”，在改造中实施“一院一策”。",
      "image": "http://cst.hzcst.cn/guodi/tACYwwestJ.jpg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621022787793",
      "title": "2022年湖滨街道旧改项目",
      "name": "上城区",
      "content": "改造项目包括青年路、东平巷、涌金门、吴山路、东坡路五个社区29个小区。改造过程中，做“看得见”“听得到”“用得上”的事。",
      "image": "http://cst.hzcst.cn/guodi/FQ7PDsRHyY.jpg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621022853329",
      "title": "濮家联合社区（濮家社区、机神社区）",
      "name": "上城区",
      "content": "闸弄口街道濮家联合社区通过硬件设施改造，以“一老一小”公共服务场景为核心，全面提升居民生活品质，突出智慧赋能的特色场景，打造乐活宜居的生活共融圈。",
      "image": "http://cst.hzcst.cn/guodi/MjjTwQyBk6.jpg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621022918865",
      "title": "艮园社区",
      "name": "拱墅区",
      "content": "潮鸣街道艮园社区在旧改过程中构建起“党建引领+基层治理”的旧改新模式，将党建统领的工作格局落实到每一个微网格的治理之中，与居民共享“共富”的美丽新蓝图。",
      "image": "http://cst.hzcst.cn/guodi/yDaZxGC5NB.jpg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621022984401",
      "title": "翠苑一区",
      "name": "西湖区",
      "content": "翠苑街道翠苑一区改造过程中着力打造“看得见的昔日旧景、听得到的殷切关怀、寻得到的红色根脉、可复制的治理经验、唱得响的翠苑品牌”。",
      "image": "http://cst.hzcst.cn/guodi/cdMpM3Rsht.jpg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621023049937",
      "title": "求智社区",
      "name": "西湖区",
      "content": "西溪街道求智社区通过“拆一点、改一点、借一点”，深挖社区可利用的内外部空间，实现空间功能复合利用，满足居民15分钟生活服务圈需求。",
      "image": "http://cst.hzcst.cn/guodi/ytERNaakcy.jpeg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621023115473",
      "title": "上保社区",
      "name": "西湖区",
      "content": "北山街道上保社区以“和美善治、邻里同行”为主题，实现家庭、社区和城市有机融合，构建可识别、可体验、可复制的老旧小区体系。",
      "image": "http://cst.hzcst.cn/guodi/aHPfnxKhec.jpeg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621023181009",
      "title": "珊瑚沙家园",
      "name": "西湖区",
      "content": "转塘街道珊瑚沙家园改造以绿色环保为基调，改造停车位、非机动车停车位、门楼；改造体育建设场地、文化休闲场地、儿童活动场所，更好满足“服务一老，照护一小”需求。",
      "image": "http://cst.hzcst.cn/guodi/GM4pdPyHwK.jpg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621023246545",
      "title": "新世纪花苑",
      "name": "西湖区",
      "content": "三墩镇新世纪花苑改造提升原公共活动空间，增加了各种功能设施。屋顶补漏，困扰多年的室内渗水问题得以解决。整改地下雨污管网，解决小区排污难问题。",
      "image": "http://cst.hzcst.cn/guodi/ZpbfEerJim.jpg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621023312081",
      "title": "春波小区（春波东苑、春波西苑）",
      "name": "滨江区",
      "content": "长河街道春波小区通过“微整形”让小区重获生机，舒适的室外聚会小场地、健身区、秋千架、社区引导系统、小夜灯等，公共服务、环境卫生、配套设施有了大提升。",
      "image": "http://cst.hzcst.cn/guodi/sxP7EhsW3z.jpg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621023377617",
      "title": "迎春小区",
      "name": "滨江区",
      "content": "西兴街道迎春小区坚持“综合改一次”理念，推进“并联一体式”施工。通过整治后，风貌环境焕然一新，生活空间全龄友好，车位增加出行更畅，设施设备智慧安全，多层加梯全覆盖，提升居民幸福指数。",
      "image": "http://cst.hzcst.cn/guodi/QbYxeMHi5i.jpg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621023443153",
      "title": "南门江社区",
      "name": "萧山区",
      "content": "城厢街道南门江社区（南江公寓、南门江住宅区）改造中进一步配齐配优小区设施设备，优化居家养老设施，增添文化宣传氛围，打造15分钟品质文化生活圈，让居民生活更舒心、便捷。",
      "image": "http://cst.hzcst.cn/guodi/xacwBN4tA7.jpg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621023508689",
      "title": "崇化三区",
      "name": "萧山区",
      "content": "城厢街道俊良社区崇化三区持续完善小区功能，畅通生命通道，搭建口袋公园，赋能现代生活，打造舒心、宜居、便捷的生活圈。",
      "image": "http://cst.hzcst.cn/guodi/zywjfbtBcx.jpeg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621023574225",
      "title": "振宁社区",
      "name": "萧山区",
      "content": "宁围街道振宁社区通过“连片改、综合改、整体改”使五个老旧小区集体实现环境改善、功能提升、颜值焕新。同时，通过融合未来社区各大场景和宁围文化精神，构建省心、舒心、安全、智慧、和谐的幸福社区。\n\n",
      "image": "http://cst.hzcst.cn/guodi/GAT8Fkd87W.jpeg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621023639761",
      "title": "花苑新村",
      "name": "余杭区",
      "content": "良渚街道花苑新村以打造智慧安防小区为目标，贯通消防车通道，新增宅间绿化、车位，加装电梯，充分挖掘满足多样人群需求的公共空间。",
      "image": "http://cst.hzcst.cn/guodi/TkJJWF8Pz8.jpg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621023705297",
      "title": "金源公寓",
      "name": "余杭区",
      "content": "余杭街道金源公寓充分营造以人为本的宜居之所，使建筑、景观、场所充分服务于人、应用于人，为老人提供“乐享天伦、颐养天年”的品质生活。",
      "image": "http://cst.hzcst.cn/guodi/Qa6m4mMPEt.jpg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621023770833",
      "title": "临平街道协办宿舍、油车弄",
      "name": "临平区",
      "content": "临平街道协办宿舍、油车弄小区提升改造项目，以优化建筑立面、完善设施配套、提升景观环境为目标，坚持“规、建、管、养、监”并重，“留、提、改、拆、建”统筹，营造良好的人居环境。",
      "image": "http://cst.hzcst.cn/guodi/hrNW3MWKAQ.jpeg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621023836369",
      "title": "东湖公寓",
      "name": "临平区",
      "content": "南苑街道东湖公寓以新一代宋韵风貌升级呈现，从建筑立面到园林景观，从邻里中心到成片加梯，复刻人民心底理想生活的模样，顺应人民群众对美好生活的向往。",
      "image": "http://cst.hzcst.cn/guodi/iSr8R7TXkm.jpg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621023901905",
      "title": "狮子山花园",
      "name": "富阳区",
      "content": "富春街道狮子山花园通过改造内部设施焕然一新，沥青路面平整宽阔，增设车位，管网通畅，预留了加装电梯所需空间，居民有了更舒适的休闲娱乐场所。",
      "image": "http://cst.hzcst.cn/guodi/7tC2XsAbNw.jpg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621023967441",
      "title": "锦城街道八号区块",
      "name": "临安区",
      "content": "临安区锦城街道以“紧扣民生所需、打造现代社区、塑造特色文化”为方向，通过改前改中多轮协调，着重系统化梳理需求；通过增设各类服务设施，着眼全方位补缺功能；通过提升关键公共空间，着力节点式凸显文化。",
      "image": "http://cst.hzcst.cn/guodi/CH25PF3BkQ.jpg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621024032977",
      "title": "邻里社区",
      "name": "钱塘区",
      "content": "白杨街道邻里社区通过整治，室外活动场地增加，缓解社区停车紧张问题，小区各处均可满足老年人及行动不便人员基本的安全通行需求，提高小区安防水平。",
      "image": "http://cst.hzcst.cn/guodi/ZaSQEb6Gpc.jpg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621024098513",
      "title": "北银公寓",
      "name": "钱塘区",
      "content": "白杨街道北银公寓完成屋面平改坡、墙面刷新等多项提升，同时改善“一老一小”主题公园，提升完善银杏长廊步道等便民设施。",
      "image": "http://cst.hzcst.cn/guodi/Ei2CsrePw6.jpg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621024164049",
      "title": "南洋新村",
      "name": "桐庐县",
      "content": "城南街道南洋新村通过改造，改善了小区的基础设施和配套功能设施，同时结合“一老一小”打造娱乐休闲主体公园，提升了居民生活环境，提高了生活品质。",
      "image": "http://cst.hzcst.cn/guodi/tEZ5YdeQdm.jpg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621024229585",
      "title": "梧桐公寓",
      "name": "桐庐县",
      "content": "城南街道梧桐公寓本次改造结合城市功能更新，听取群众意见，在完善基础设施、优化居住环境、提升服务功能、打造小区特色和强化长效管理等方面全面提升，提高了老百姓的满意度和幸福感。",
      "image": "http://cst.hzcst.cn/guodi/F8CiBMThh8.jpg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621024295121",
      "title": "2022年千岛湖镇旧改造项目",
      "name": "淳安县",
      "content": "项目涉及新塘一区、新塘二区、阳光路区块、新安北路区块、龙门路区块。坚持“小改造、大民生”的理念，“花小钱、办大事”将老旧小区改造重点放在完善基础配套、消除安全隐患，提升小区居住品质。\n\n",
      "image": "http://cst.hzcst.cn/guodi/nAckX6fhm4.jpg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621024360657",
      "title": "宏都小区",
      "name": "建德市",
      "content": "新安江街道宏都小区以“健康17度”为设计主题和理念，改善了小区的基础设施和配套功能设施，提升了居民的生活品质和幸福感，彰显了小区的整体形象和文化内涵。",
      "image": "http://cst.hzcst.cn/guodi/NQjQP2e6N5.jpg",
      "like": 0,
      "checked": false
    },
    {
      "id": "346203621024426193",
      "title": "水碓巷区块",
      "name": "建德市",
      "content": "新安江街道水碓巷区块遵循“邻里相望、文化相连、生活相关”原则，新增基础设施和口袋公园，实现“住有所居”到“住得宜居”转变。",
      "image": "http://cst.hzcst.cn/guodi/CmewRrkNJW.jpg",
      "like": 0,
      "checked": false
    }
  ];}


// WEBPACK FOOTER //
// ./src/utils/data.js